export const createUniqueIdentifier = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const time = Date.now().toString(36);
  return `${time}-${Math.random().toString(36).slice(2, 10)}`;
};
